module.exports = __webpack_public_path__ + "img/menubar.c79b3a75.png";